function decorateTopListItem(elem, storage) {
  const output = { ...elem };
  output.id = output.organizationId;

  const storageItem = storage.find((item) => {
    return item.id?.toString() === output.id || item.oldId?.toString() === output.id;
  });

  if (storageItem) {
    const { name, alias, logotypes, logo, partnerCard, isRecomended, isPremiumPartner } = storageItem;
    output.name = name?.short || name || '';
    output.alias = alias || '';
    output.logo = logotypes?.square || logotypes?.android || logo;
    output.partnerCard = partnerCard;
    output.isPremiumPartner = isPremiumPartner;
    output.isRecomended = isRecomended;
    output.organizationType = storageItem.type ?? storageItem.organizationType ?? 'insuranceCompany';
  }

  return output;
}

function decorateTopList(list, storage) {
  return list
    .map((elem) => decorateTopListItem(elem, storage))
    .filter((item) => {
      if (item.organizationType === 'bank') {
        return item.isPremiumPartner || item.approved > 300;
      }
      if (item.organizationType === 'insuranceCompany') {
        return item.isRecomended || item.isPremiumPartner;
      }
      if (item.organizationType === 'mfo') {
        return item.partnerCard || item.approved > 0;
      }
      return false;
    });
}

export function getPartnersList({ organizations = [], ratings }) {
  if (organizations.length && ratings.length) {
    const topList = decorateTopList(ratings, organizations);

    let premiumList = topList.filter((item) => {
      if (item.organizationType === 'bank') {
        return item.isPremiumPartner;
      }
      if (item.organizationType === 'insuranceCompany') {
        return item.isRecomended;
      }
      if (item.organizationType === 'mfo') {
        return item.partnerCard;
      }
      return false;
    });

    topList.forEach((item) => {
      if (
        premiumList.length < 14 &&
        premiumList.every(
          (el) => item.id?.toString() !== el.oldId?.toString() && item.id?.toString() !== el.id?.toString(),
        )
      ) {
        premiumList.push(item);
      }
    });

    return premiumList;
  }

  return [];
}

export const makeEvenList = (list) => {
  let res = list;

  if (list.length && list.length % 2) {
    const topFirstPart = list.slice(0, (list.length + 1) / 2);
    const topSecondPart = list.slice(0, (list.length - 1) / 2);
    const bottomFirstPart = list.slice((list.length - 1) / 2, list.length);
    const bottomSecondPart = list.slice((list.length + 1) / 2, list.length);

    res = topFirstPart.concat(topSecondPart).concat(bottomFirstPart).concat(bottomSecondPart);
  }

  return res;
};
